<template>
  <div class="produto-cdlsaude-planos">
    <div class="content">
      <Titulo
        class="py-4"
        :title="'Preencha os dados do ' + titulo"
        description="Aqui vai uma explicação sobre esta página, o que ela faz, por exemplo."
      />
      <div class="row align-items-center mb-4 busca-planos">
        <div class="col-md-5 col-lg-4">
          <FormulateInput
            type="text"
            v-model="nome"
            name="Nome Completo"
            placeholder="Nome Completo"
            validation="required"
          />
        </div>
        <div class="col-md-4 col-lg-3 mt-3 mt-md-0">
          <FormulateInput
            type="date"
            v-model="dataNascimento"
            name="Data Nascimento"
            label="Data de Nascimento"
            placeholder="Data Nascimento"
            validation="required"
            @change="recarregarPlanos"
          />
        </div>
        <div class="col-md-3 mt-3 mt-md-0">
          <Botao
            title="LISTAR PLANOS"
            @click="listarOperadora"
            nameClass="btn btn-form btn-block"
            :class="{ disabled: !nome || !dataNascimento }"
          >
            <Loading v-if="listarOperadoraLoading" />
            <span v-else>
              <div v-if="!codPlanoFx">LISTAR PLANOS</div>
              <div v-else>CONSULTAR PLANO</div>
            </span>
          </Botao>
        </div>
      </div>

      <div class="lista-planos" v-if="!Object.keys(plano).length">
        <div
          v-for="operadora in operadoras"
          :key="operadora.codoperadora"
          class="card border-0 mt-3"
        >
          <div
            class="card-header bg-white cursor-pointer operadora-header"
            @click="listarAssistenciaSaude(operadora)"
          >
            <h2 class="mb-0 font-weight-bold">
              {{ operadora.operadora }}
            </h2>
          </div>
          <transition name="fade">
            <div
              class="card-body p-0"
              v-if="operadoraShow === operadora.codoperadora"
            >
              <div
                class="p-3"
                v-if="listarAssistenciaSaudeLoading === operadora.codoperadora"
              >
                <Loading width="30" height="30" />
              </div>
              <div v-else>
                <div
                  class="row justify-content-between align-items-center px-3 pb-3"
                  v-for="(assistencia, index) in assistencias"
                  :key="assistencia.cod"
                >
                  <div class="col-12 pb-3">
                    <hr v-if="index" class="d-md-none m-0" />
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <div class="d-md-none">
                      <span class="badge badge-light border mb-1">{{
                        operadora.operadora
                      }}</span>
                    </div>
                    {{ assistencia.assistencia }}
                  </div>
                  <div class="col-md-3 col-lg-3 mt-2 mt-md-0">
                    <small>Acomodação:</small><br />
                    {{ assistencia.acomodacao }}
                  </div>
                  <div class="col-md-2 col-lg-3 text-md-right mt-2 mt-md-0">
                    {{ assistencia.valor | currency }} mensal
                  </div>
                  <div class="col-md-3 col-lg-2 text-md-right mt-2 mt-md-0">
                    <transition name="fade">
                      <b-button
                        class="btn-block"
                        variant="success"
                        @click="selecionarPlano(assistencia)"
                        v-if="opcionaisShow !== assistencia.codPlano"
                        >SELECIONAR</b-button
                      >
                    </transition>
                  </div>
                  <div
                    v-if="opcionaisShow === assistencia.codPlano"
                    class="col-md-12 mt-3"
                  >
                    <div class="lista-opcoes rounded">
                      <FormulateInput
                        type="checkbox"
                        v-model="opcionais"
                        :options="listaOpcionais"
                        label="Este plano tem opcionais disponíveis:"
                        @input="selecionarOpcional"
                      />
                      <FormulateInput
                        type="button"
                        value="SALVAR E SELECIONAR"
                        @click="salvar"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-else>
        <div class="mt-5">
          <div class="lista-planos">
            <div class="card border-0 mt-3">
              <div class="card-header bg-white cursor-pointer operadora-header">
                <h2 class="mb-0 font-weight-bold">
                  {{ plano.operadora }}
                </h2>
              </div>
              <div class="card-body p-0">
                <div
                  class="row justify-content-between align-items-center px-3 pb-3"
                >
                  <!-- {{ plano }}
                  {{ codPlanoFx }} -->
                  <div class="col-md-4 col-lg-4">
                    <div class="d-md-none">
                      <span class="badge badge-light border mb-1">{{
                        plano.operadora
                      }}</span>
                    </div>
                    {{ plano.assistencia }}
                  </div>
                  <div class="col-md-3 col-lg-3 mt-2 mt-md-0">
                    <small>Acomodação:</small><br />
                    {{ plano.acomodacao }}
                  </div>
                  <div class="col-md-2 col-lg-3 text-md-right mt-2 mt-md-0">
                    {{ plano.valor | currency }}
                  </div>
                  <div class="col-md-3 col-lg-2 text-md-right mt-2 mt-md-0">
                    <transition name="fade">
                      <b-button
                        class="btn-block"
                        variant="success"
                        @click="selecionarPlano(plano)"
                        v-if="opcionaisShow !== plano.codPlanoFx"
                        >SELECIONAR</b-button
                      >
                    </transition>
                  </div>
                  <div
                    v-if="opcionaisShow === plano.codPlanoFx"
                    class="col-md-12 mt-3"
                  >
                    <div class="lista-opcoes rounded">
                      <FormulateInput
                        type="checkbox"
                        v-model="opcionais"
                        :options="listaOpcionais"
                        label="Este plano tem opcionais disponíveis:"
                        @input="selecionarOpcional"
                      />
                      <FormulateInput
                        type="button"
                        value="SALVAR E SELECIONAR"
                        @click="salvar"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-md-4 col-lg-2">
          <Botao
            title="Voltar"
            :link="linkVoltar"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
      </div>
    </div>
    <div class="py-5"></div>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
// import ListaPlanos from '@/components/planos/ListaPlanos'
import Botao from "@/components/botoes/Botao";
import Loading from "@/components/loaders/Puff.vue";
// import Loading from '../../../components/Loading.vue'
export default {
  name: "Planos",
  components: {
    Titulo,
    // ListaPlanos,
    Botao,
    Loading,
  },
  data() {
    return {
      listarOperadoraLoading: false,
      listarAssistenciaSaudeLoading: 0,
      titulo: "titular",
      idCadastro: "",
      produto: {
        nome: "CDL Saúde",
        id: "CDL Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Plano de Saúde",
          id: "plano_saude",
        },
      ],
      nome: null,
      dataNascimento: null,
      planos: [],
      plano: {},
      opcionais: [],
      listaOpcionais: [],
      operadoraShow: 0,
      operadoras: [],
      assistencias: [],
      opcionaisShow: "",
      codPlanoFx: false,
      linkVoltar: "/produto/cdl-consultor/cdl-saude",
    };
  },
  methods: {
    async listarOperadora() {
      this.listarOperadoraLoading = true;
      if (!this.dataNascimento) {
        this.listarOperadoraLoading = false;
        return false;
      }
      if (this.codPlanoFx) {
        await this.$http
          .post("api/GestaoSaude/ListarPlanoDependente", {
            codPlanoFx: this.codPlanoFx,
            dtNascimento: this.dataNascimento,
          })
          .then((response) => {
            this.plano = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
        this.listarOperadoraLoading = false;
      } else {
        await this.$http
          .get("/api/GestaoSaude/ListarOperadora")
          .then((response) => {
            this.operadoras = response.data;
            const unimed = this.operadoras.filter(
              (el) => el.operadora == "UNIMED BH"
            );
            this.listarAssistenciaSaude(...unimed);
          })
          .catch((error) => {
            console.log(error);
            this.listarOperadoraLoading = false;
          });
        this.listarOperadoraLoading = false;
      }
    },
    async listarAssistenciaSaude(operadora) {
      this.operadoraShow = operadora.codoperadora;
      this.listarAssistenciaSaudeLoading = operadora.codoperadora;
      await this.$http
        .get(
          "/api/GestaoSaude/ListarAssistenciaSaude?operadora=" +
            operadora.codoperadora
        )
        .then(async (response) => {
          this.assistencias = [];
          for (const assistencia of response.data) {
            await this.ListarPlanoSaude(
              operadora.codoperadora,
              operadora.operadora,
              assistencia.codassist,
              assistencia.assistencia
            );
          }
        });
      this.listarAssistenciaSaudeLoading = false;
    },
    async ListarPlanoSaude(
      codOperadora,
      nomeOperadora,
      codAssistencia,
      nomeAssistencia
    ) {
      await this.$http
        .post("/api/GestaoSaude/ListarPlanoSaude", {
          aniversario: this.dataNascimento,
          codOperadora: codOperadora,
          codAssistencia: codAssistencia,
        })
        .then((responsePlanos) => {
          for (const plano of responsePlanos.data) {
            if (plano) {
              this.assistencias.push({
                codPlano: plano.codplanofx,
                codAssistencia: codAssistencia,
                assistencia: nomeAssistencia,
                codOperadora: codOperadora,
                operadora: nomeOperadora,
                acomodacao: plano.tipoassistencia,
                valor: plano.valor,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selecionarPlano(plano) {
      this.assistencia = plano;
      this.opcionais = [];
      this.listaOpcionais = [];
      // Consulta os opcionais
      this.$http
        .get("/api/CdlBh/ListarOpcional?assistencia=" + plano.codAssistencia)
        .then(async (response) => {
          response.data.forEach((v) => {
            if (
              v.codopcional === "0002" ||
              v.codopcional === "0004" ||
              v.codopcional === "0020"
            ) {
              this.listaOpcionais.push({
                value: v.codopcional,
                label: `${v.opcional} (+${this.$options.filters.currency(
                  v.valor
                )})`,
                price: v.valor,
              });
            }
          });
        });
      this.opcionaisShow = plano.codPlano ?? plano.codPlanoFx;
    },
    selecionarOpcional() {
      var array = this.opcionais;
      if (this.opcionais.length > 1) {
        var ultimo = array[array.length - 1];
        if (ultimo == "0002") {
          if (this.opcionais.includes("0004")) {
            this.opcionais.splice(this.opcionais.indexOf("0004"), 1);
          }
        }
        if (ultimo === "0004") {
          if (this.opcionais.includes("0002")) {
            this.opcionais.splice(this.opcionais.indexOf("0002"), 1);
          }
        }
      }
    },
    salvar() {
      var registro = {
        nome: this.nome,
        tipoCadastro: this.titulo,
        dataNascimento: this.dataNascimento,
        plano: this.assistencia,
      };
      var registros = [];
      var opcionais = [];
      var descOpcionais = [];

      for (const op of this.opcionais) {
        opcionais.push({
          codopcional: parseInt(op),
        });

        let opcional = this.listaOpcionais.find((el) => el.value == op);

        descOpcionais.push({
          opcional,
        });
      }

      registro.opcionais = opcionais;
      registro.descOpcionais = descOpcionais;

      if (JSON.parse(localStorage.getItem("cdlsaude_cadastro"))) {
        registros = JSON.parse(localStorage.getItem("cdlsaude_cadastro"));
      }

      if (this.idCadastro !== "") {
        registros[this.idCadastro] = registro;
      } else {
        registros.push(registro);
      }

      const parsed = JSON.stringify(registros);
      localStorage.setItem("cdlsaude_cadastro", parsed);
      this.$router.push({ name: "cdl-saude-cadastro" });
    },
    async atualizarCadastro() {
      const registros = JSON.parse(localStorage.getItem("cdlsaude_cadastro"));
      this.nome = registros[this.idCadastro].nome;
      this.dataNascimento = registros[this.idCadastro].dataNascimento;
      if (registros[this.idCadastro].tipoCadastro === "dependente") {
        this.codPlanoFx = registros[this.idCadastro].plano.codPlanoFx;
      }

      this.listarOperadora();
      const plano = registros[this.idCadastro].plano;
      await this.selecionarPlano(plano);
      registros[this.idCadastro].descOpcionais.forEach((el) => {
        this.opcionais.push(el.opcional.value);
      });
    },
    verificarTitular() {
      if (JSON.parse(localStorage.getItem("cdlsaude_cadastro"))) {
        var registros = JSON.parse(localStorage.getItem("cdlsaude_cadastro"));
        registros.forEach((registro) => {
          if (
            registro.tipoCadastro === "titular" &&
            this.titulo === "titular"
          ) {
            this.titulo = "dependente";
            this.$router.push({
              name: "cdl-saude-planos",
              query: { tipoCadastro: "dependente" },
            });
          }
          this.linkVoltar = "/produto/cdl-consultor/cdl-saude-cadastro";
          if (registro.tipoCadastro === "titular") {
            this.codPlanoFx = registro.plano.codPlano;
          }
        });
      }
    },
    recarregarPlanos() {
      this.operadoras = [];
    },
    autopreencher() {
      this.nome = this.$user.dadosContatoPrincipal[0].nome;
      this.dataNascimento =
        this.$user.dadosContatoPrincipal[0].datA_NASCIMENTO.split("T")[0];
      sessionStorage.setItem("autopreencher_inclusao_vida", true);
    },
  },
  mounted() {
    this.titulo = this.$route.query.tipoCadastro;
    if (typeof this.titulo === "undefined") {
      this.$router.push({ name: "cadastro" });
    }
    if (typeof this.$route.query.id !== "undefined") {
      this.idCadastro = this.$route.query.id;
      this.atualizarCadastro();
    } else {
      this.verificarTitular();
    }
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";
.produto-cdlsaude-planos /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  line-height: 1.4;
  .busca-planos {
    .formulate-input {
      position: relative;
      padding-left: 18px;
      padding-right: 18px;
      background-color: white;
      min-height: 60px;
      display: inline-flex;
      width: 100%;
      align-items: center;
    }
  }

  .operadora-header {
    cursor: pointer;
  }

  small {
    font-size: 0.8rem;
  }

  .lista-opcoes {
    background: $dark-100;
    .formulate-input-label {
      margin-bottom: 10px;
      font-weight: 700;
      padding: 0.8rem;
    }
    .formulate-input-group {
      .formulate-input-label {
        margin-bottom: 7px;
        font-weight: 400;
        padding: 0rem;
      }
      .formulate-input-element--checkbox {
        margin-right: 5px;
      }
    }
    .formulate-input.formulate-input-group-item {
      padding: 0.8rem;
      label {
        margin: 0;
      }
      &[data-has-value="true"] {
        background: $dark-200;
      }
    }

    .formulate-input[data-classification="button"] {
      padding: 0.8rem;
    }

    formulate-input-errors {
      // Global error message list wrapper
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .formulate-input-error,
    .formulate-file-upload-error {
      // Error message styles
      padding: 6px 8px;
      background-color: #ff5c5c;
      color: white;
      font-size: 12px;
    }
  }
}
</style>
